import { useMutation, useQueryClient } from '@tanstack/react-query';
import { quoteCoverageOptions } from '../../../../../api/submissions/submission-coverages.api';
import type { QuoteOptionsRequest } from '../../../../../api/submissions/submission-coverages.types';
import { getData } from '../../../../../utils/functional/fp';
import { invalidateSubmissionCoverage } from './invalidateSubmissionCoverage';

/** The body the cart submit sent, plus the agency id it sent as a query param. */
export type QuoteRequest = QuoteOptionsRequest & { agencyId?: string };

/** Quotes each selected option on its own; the result carries one entry per option. */
export const useRequestQuotesForOptions = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ agencyId, ...data }: QuoteRequest) =>
      quoteCoverageOptions(submissionId, {
        data,
        ...(agencyId && { params: { agencyId } }),
      }).then(getData),
    onSettled: () => invalidateSubmissionCoverage(queryClient, submissionId),
  });
};
